module.exports = __webpack_public_path__ + "img/Newbie_Bow_03_Mage.194ab257.png";